import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// i18n
import { withTranslation } from "react-i18next";
import UserDetailsModal from "./UserProfile/UserDetailModel";

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      isModalOpen: false,
      username: "Admin",
      userInitials: "A",
    };
    this.toggle = this.toggle.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateUserDetails = this.updateUserDetails.bind(this);
  }

  componentDidMount() {
    this.updateUserDetails();
    // Add event listener for localStorage changes
    window.addEventListener('storage', this.handleStorageChange);
    // Add event listener for custom events (for same-tab updates)
    window.addEventListener('userDetailsUpdated', this.updateUserDetails);
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('userDetailsUpdated', this.updateUserDetails);
  }

  handleStorageChange = (e) => {
    if (e.key === 'userDetails') {
      this.updateUserDetails();
    }
  };

  updateUserDetails() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails) {
      const firstName = userDetails.first_name || "";
      const lastName = userDetails.last_name || "";
      const username = `${firstName} ${lastName}`;
      const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
      
      this.setState({
        username,
        userInitials: initials || "A"
      });
    } else {
      this.setState({
        username: "Admin",
        userInitials: "A"
      });
    }
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  render() {
    return (
      <React.Fragment>
        {/* Profile dropdown button */}
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block user-dropdown"
        >
          <DropdownToggle
            tag="button"
            className="btn header-item waves-effect d-flex align-items-center"
            id="page-header-user-dropdown"
          >
            {/* Profile Icon with Initials */}
            <div
              className="rounded-circle header-profile-user d-flex align-items-center justify-content-center"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#007bff", // Default background color
                color: "#fff", // Text color
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {this.state.userInitials}
            </div>

            <span
              className="ms-2 d-inline-block"
              style={{
                fontWeight: "bold", // Bold font for the username
                fontSize: "14px", // Slightly larger text for better visibility
                color: "#333", // Neutral color for text
                lineHeight: "1.2", // Adjust line height for clean appearance
              }}
            >
              {this.state.username}
            </span>

            <i
              className="mdi mdi-chevron-down ms-2"
              style={{
                color: "#666", // Chevron arrow color
                fontSize: "18px", // Slightly larger for better visibility
              }}
            ></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem onClick={this.openModal}>
              <i className="ri-user-line align-middle me-1"></i>{" "}
              {this.props.t("Profile")}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem tag="a" href="/logout" className="text-danger">
              <i className="ri-shut-down-line align-middle me-1 text-danger"></i>{" "}
              {this.props.t("Logout")}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>

        {/* Modal for displaying user details */}
        {this.state.isModalOpen && (
          <UserDetailsModal onClose={this.closeModal} id={null} type="user" />
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation()(ProfileMenu);
